import React from 'react'
import { AdminSidebarLayout } from '../../components/AdminSidebar'
import { empty } from '../../assets/assets'
import { Link } from 'react-router-dom'
import { AdminHeader } from '../../components/components'

const AddNewGig = () => {
    return (

        <AdminSidebarLayout currentPath="/add-new-gig">
            <div className="bg-[#F5F5F5] min-h-screen px-4 py-8">
                <AdminHeader/>
                <div className="container mx-auto">
                    <div className="bg-white flex flex-col gap-3 py-10 items-center justify-center">
                        <img src={empty}/>
                        <p className='text-[17px] text-[#AFAFAF] font-[poppins]'>There are no gigs here at the moment</p>
                         <Link to={'/admins/new-gig'} className='text-[20px] text-black font-[poppins] underline'>ADD NEW GIG</Link>
                    </div>
                </div>
            </div>
        </AdminSidebarLayout>
    )
}

export default AddNewGig